module.exports = __webpack_public_path__ + "img/logod.cb8d8f60.png";